import { render, staticRenderFns } from "./InitForm.vue?vue&type=template&id=f87b19aa&scoped=true"
import script from "./InitForm.vue?vue&type=script&lang=js"
export * from "./InitForm.vue?vue&type=script&lang=js"
import style0 from "./InitForm.vue?vue&type=style&index=0&id=f87b19aa&prod&scoped=true&lang=css"
import style1 from "./InitForm.vue?vue&type=style&index=1&id=f87b19aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87b19aa",
  null
  
)

export default component.exports